import React from 'react';
import Drawer from '@mui/material/Drawer';
import ChatLayout from '../ChatLayout';
import ChatProvider from '../../ChatProvider';

interface Props {
  open: boolean;
  onClose: () => void;
}

const ChatDrawer: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 1600 }}
      keepMounted={false}
      // Sendbird's message "Copy" action appends a <textarea> to document.body (outside this
      // Drawer's Modal), selects it, and runs execCommand('copy'). The Modal focus-trap would
      // otherwise pull focus back in, clearing that selection before the copy fires — leaving
      // the clipboard empty. Disabling focus enforcement lets the copy succeed. (DA-19511)
      ModalProps={{ disableEnforceFocus: true }}
      PaperProps={{
        sx: {
          width: { xs: '100vw', md: 'min(960px, 100vw)' },
          userSelect: 'text',
        },
      }}
    >
      <ChatProvider>
        <ChatLayout onClose={onClose} />
      </ChatProvider>
    </Drawer>
  );
};

export default ChatDrawer;
